<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { getCurrentVariant } from "../../../functions/helper/product"
    export let possibleSizeVariants: BKDFProductVariant[] = [],
        selectedColor: BKDFProductSelectedOption,
        selectedSize: BKDFProductSelectedOption,
        product: BKDFProduct

    const dispatch = createEventDispatcher()
</script>

<section id="sizing">
    <div class="heading"><em><small>CHOOSE SIZE</small></em> <button>Größentabelle</button></div>
    <ul class="sizes">
        {#each possibleSizeVariants.map((v) => v.selectedOptions.find((o) => o.name === "Größe").value) as value}
            <li
                class:active="{selectedSize?.value === value}"
                class="{selectedColor
                    ? getCurrentVariant(product, [{ name: 'Größe', value }, selectedColor])?.availableForSale
                        ? 'forSale'
                        : 'notForSale'
                    : 'forSale'}"
            >
                <button
                    on:click="{() => {
                        dispatch('sizeChange', { size: value })
                    }}"
                >
                    {value}
                </button>
            </li>
        {/each}
    </ul>
</section>

<style lang="less">
    #sizing {
        display: flex;
        flex-direction: column;
        gap: 12px;
        .heading {
            display: flex;
            justify-content: space-between;
            align-items: center;
            button {
                color: var(--text-invers-100);
            }
        }
        .sizes {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            width: 100%;
            flex-wrap: wrap;
            li {
                flex-grow: 1;
                height: 2rem;

                min-width: 4rem;
                flex-shrink: 0;

                border-radius: 2px;
                border: 1px solid var(--bg-300);
                &.notForSale {
                    button {
                        text-decoration: line-through;
                    }
                    pointer-events: none;
                    opacity: 0.5;
                }
                &.active {
                    border: 1px solid var(--primary-100);
                }
                button {
                    padding: 0rem 1.2rem 0rem 1.2rem;
                    cursor: pointer !important;
                    width: 100%;
                    height: 100%;
                    color: var(--text-invers-100);
                }
            }
        }
    }
</style>
